import React, { useState } from "react";
import { Badge, Card, Col, Form, Row } from "react-bootstrap";
import { Note } from "../../../../types/note";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "react-tooltip";

interface GroupMeetingViewState {
  n: Note;
  downloadReport: any;
  setReportType: any;
}

const GroupMeetingView = ({ n, downloadReport, setReportType }: GroupMeetingViewState) => {
  const [running, setRunning] = useState<boolean>(false);

  const onClickDownload = async (e: any) => {
    e.stopPropagation();
    setRunning(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));

    setReportType("Group Meeting");
    const download = await downloadReport(e, n);
    setRunning(false);
  };

  return (
    <Card id={"note-card-" + n?.id} className="bg-light mb-3">
      <Card.Body>
        <>
          <Row>
            <Col>
              <h5 className="app-orange-text">Group Meeting</h5>
            </Col>
            <Col className="text-end">
              <label className="note-type text-muted me-3">{n.fields.date}</label>
              <FontAwesomeIcon
                data-tooltip-id={"note-download-tooltip-" + n?.id}
                data-tooltip-content="Download Note"
                id={"note-download-button-" + n?.id}
                className="text-muted cursor-pointer"
                icon={faDownload}
                onClick={(e) => onClickDownload(e)}
              />
              <Tooltip id={"note-download-tooltip-" + n?.id} place="top" style={{ padding: "5px 10px" }} />
            </Col>
          </Row>
          <Row>
            <h6 className="app-header-text">{n?.fields?.group_name}</h6>
          </Row>
          <Row>
            <div
              id="capture-text"
              style={{
                height: running ? "auto" : "80px",
                pointerEvents: "none",
                backgroundColor: "#e9ecef",
                color: "#6c757d",
                whiteSpace: "pre-wrap",
                wordWrap: "break-word",
                overflow: "hidden",
                border: "1px solid #ccc",
                padding: "5px",
                marginBottom: "5px",
              }}
            >
              {n.fields.group_note ? n.fields.group_note : ""}
            </div>
          </Row>
          {n.fields?.individual_note && (
            <Row>
              <div
                id="capture-text"
                style={{
                  height: running ? "auto" : "80px",
                  pointerEvents: "none",
                  backgroundColor: "#e9ecef",
                  color: "#6c757d",
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                  overflow: "hidden",
                  border: "1px solid #ccc",
                  padding: "5px",
                }}
              >
                {n.fields.individual_note ? n.fields.individual_note : ""}
              </div>
            </Row>
          )}
          <Row className="mt-1">
            <Col className="col-6 text-start">
              <Badge bg="secondary">
                Created By {n.firstname} {n.lastname}
              </Badge>
            </Col>
            <Col className="col-6 text-end">
              {n.subject?.room && (
                <Badge bg="secondary" className="me-2">
                  {n.subject?.room + " " + n.subject?.bed}
                </Badge>
              )}
              <Badge bg="secondary">{n.subject?.name}</Badge>
            </Col>
          </Row>
        </>
      </Card.Body>
    </Card>
  );
};

export default GroupMeetingView;
